import cx from "classnames";

import { Paragraph } from "common/ui/Paragraph";
import { Icon } from "common/ui/Icon";

import styles from "./ProgressBar.module.scss";

interface Props {
  numSteps: number,
  currStep: number,
  color?: "purple" | "blue",
  hideSteps?: boolean,
}

export function ProgressBar({
  numSteps,
  currStep,
  color = "purple",
  hideSteps,
}: Props) {
  return (
    <div className={styles.Container}>
      <div className={styles.Bar}>
        <div
          className={cx(styles.Progress, {
            [styles.purple]: color === "purple",
            [styles.blue]: color === "blue",
          })}
          style={{ width: `${(currStep / numSteps) * 100}%` }}
        />
      </div>
      {hideSteps ? (
        null
      ) : currStep === numSteps ? (
        <Icon icon={"check"} className={styles.CheckMark} />
      ) : (
        <Paragraph variant="p1">
          {`${currStep}/${numSteps}`}
        </Paragraph>
      )}
    </div>
  )
};

